import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Editorial section "eyebrow" used at the top of premium dialogs/modals — the
 * `§ LABEL` mono kicker above the DialogTitle. Canonical recipe set by
 * UpgradeRequiredModal / AppRatingDialog. Use inside a DialogHeader, above the
 * DialogTitle, to keep every popup on one visual language:
 *
 *   <DialogHeader>
 *     <DialogEyebrow>UPGRADE</DialogEyebrow>
 *     <DialogTitle>…</DialogTitle>
 *   </DialogHeader>
 */
const DialogEyebrow = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, children, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      "font-mono text-[10px] font-semibold tracking-[0.14em] uppercase text-gray-400 dark:text-neutral-500 mb-2",
      className,
    )}
    {...props}
  >
    § {children}
  </span>
));
DialogEyebrow.displayName = "DialogEyebrow";

export { DialogEyebrow };
